import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectModalContentProps, setIsModalOpen, setModalContent } from '../../../store/slices/global';
import { useAppDispatch } from '../../../store';
import { submitReport } from '../../../api/game-mode/report';
import Headline from '../../../ui/Headline';
import Select from '../../../ui/Select';
import Button from '../../../ui/Button';
import ButtonsGroup from '../../../ui/ButtonsGroup';
import Loader from '../../../ui/Loader';
import CloseIcon from '../../../assets/icons/close.svg';
const ReportProblem = () => {
    const { t, i18n } = useTranslation();
    const dispatch = useAppDispatch();
    const modalProps = useSelector(selectModalContentProps);
    const [category, setCategory] = useState(null);
    const [description, setDescription] = useState('');
    const [status, setStatus] = useState('idle');
    const [errorMessage, setErrorMessage] = useState(null);
    const rallyId = modalProps?.rallyId;
    const taskId = modalProps?.taskId;
    const categoryOptions = [
        { label: t('report.category.error'), value: 'error' },
        { label: t('report.category.problematic_content'), value: 'problematic_content' },
        { label: t('report.category.other'), value: 'other' },
    ];
    const isFormValid = !!category && !!description.trim();
    const isDisabled = status === 'loading';
    const handleClose = () => {
        dispatch(setIsModalOpen(false));
        dispatch(setModalContent(null));
    };
    const handleSubmit = async () => {
        if (!isFormValid || !rallyId || !taskId)
            return;
        setStatus('loading');
        setErrorMessage(null);
        const response = await submitReport({
            rallyId,
            taskId,
            category,
            description: description.trim(),
            language: i18n.language,
        });
        if (response.data) {
            setStatus('success');
        }
        else if (response.error) {
            if (response.error.code === 'rate_limit_exceeded') {
                setErrorMessage(t('report.error_rate_limit'));
            }
            else {
                setErrorMessage(t('report.error_generic'));
            }
            setStatus('error');
        }
    };
    if (status === 'success') {
        return (_jsxs("div", { className: 'modal-content report-problem', children: [_jsx("button", { className: "report-problem-close", onClick: handleClose, "aria-label": "Close", children: _jsx(CloseIcon, {}) }), _jsx("div", { className: "modal-content-title", children: _jsx(Headline, { title: t('report.success_title'), type: 'h1' }) }), _jsx("div", { className: "report-problem-success", children: _jsx("p", { children: t('report.success_message') }) })] }));
    }
    return (_jsxs("div", { className: 'modal-content report-problem', children: [_jsx("button", { className: "report-problem-close", onClick: handleClose, "aria-label": "Close", children: _jsx(CloseIcon, {}) }), _jsx("div", { className: "modal-content-title", children: _jsx(Headline, { title: t('report.title'), type: 'h1' }) }), _jsxs("div", { className: "report-problem-form", children: [_jsx(Select, { placeholder: t('report.category_placeholder'), label: t('report.category_label'), options: categoryOptions, background: "game", onChange: (value) => setCategory(value), disabled: isDisabled }), _jsxs("div", { className: "report-problem-textarea-wrapper", children: [_jsx("label", { className: "report-problem-textarea-label", htmlFor: "report-description", children: t('report.description_label') }), _jsx("textarea", { id: "report-description", className: "report-problem-textarea", maxLength: 1000, placeholder: t('report.description_placeholder'), disabled: isDisabled, value: description, onChange: (e) => setDescription(e.target.value) }), _jsxs("div", { className: "report-problem-char-count", children: [description.length, "/1000"] })] }), status === 'error' && errorMessage && (_jsx("div", { className: "report-problem-error", children: errorMessage })), _jsx("div", { className: "report-problem-actions", children: _jsxs(ButtonsGroup, { justify: 'center', children: [_jsx(Button, { label: t('button.cancel'), onClick: handleClose }), _jsx(Button, { variant: 'outlined', label: t('report.send'), disabled: !isFormValid || isDisabled, onClick: handleSubmit }), isDisabled ? _jsx(Loader, {}) : undefined] }) })] })] }));
};
export default ReportProblem;
